export enum EcommItemType {
    PRODUCT = 'product',
    EVENT = 'event',
}
